import React from "react";
import DatePicker from "react-datepicker";
import PropTypes from "prop-types";

import "react-datepicker/dist/react-datepicker.css";
import { inputBoxStyles } from "../InputBox/input.style";
import ErrorLabel from "../ErrorLabel";
import "./index.scss";
import { ValueStrings } from "../../utils/constantsString";

const DupontDatePicker = React.forwardRef(
  (
    {
      id,
      label,
      labelClass,
      className,
      disabled,
      minDate,
      maxDate,
      error,
      isRequired,
      showTimeSelect = false,
      dateFormat,
      placeholderText,
      portalId = "dupont-datepicker-portal",
      popperPlacement = "bottom-start",
      popperClassName = "dupont-datepicker-popper",
      ...props
    },
    ref
  ) => {
    const classes = inputBoxStyles(this);

    const handleRawChange = (event) => {
      const inputText = event.target.value;
      if (inputText) {
        const sanitizedText = inputText.replace(/[^\w\s:]/gi, "");

        event.target.value = sanitizedText;
      }
    };

    return (
      <div>
        {label && (
          <div className={labelClass}>
            {label} {isRequired && <span style={{ color: "red" }}>*</span>}
          </div>
        )}
        <DatePicker
          {...props}
          id={id}
          disabled={disabled}
          className={`${classes.textfield} custom-input ${className}`}
          minDate={minDate}
          maxDate={
            maxDate || new Date().setFullYear(new Date().getFullYear() + 1)
          }
          minTime={props.minTime || new Date().setHours(0, 0, 0, 0)}
          maxTime={props.maxTime || new Date().setHours(23, 59, 59, 999)}
          onChangeRaw={handleRawChange}
          showTimeSelect={showTimeSelect}
          dateFormat={dateFormat || ValueStrings.DATE_FORMAT_SMALL}
          placeholderText={placeholderText || ValueStrings.dateFormat}
          shouldCloseOnSelect={false}
          portalId={portalId} 
          popperPlacement={popperPlacement}
          popperClassName={popperClassName}
        />

        {error && <ErrorLabel className="text-left " message={error} />}
      </div>
    );
  }
);

export default DupontDatePicker;
